module.exports = __webpack_public_path__ + "static/media/clients-03.587d6030.svg";